export const LandingPageBannerText = {
    primaryMessageLine1: {
        english: 'Manage your benefits',
        spanish: 'Administre sus beneficios'
    },
    primaryMessageLine2: {
        english: 'with confidence',
        spanish: 'con confianza'
    },
    secondaryMessage: {
        english: 'Workplace benefit solutions',
        spanish: 'Soluciones de beneficios en el lugar de trabajo'
    },
    eeImageAltText: {
        english: 'family in field',
        spanish: 'familia en el campo'
    },
    erImageAltText: {
        english: 'woman smiling',
        spanish: 'mujer sonriente'
    }
};
